<p-dialog [(visible)]="displayNoteDetailPopup" [modal]="true" [style]="{width: '55vw'}" class="layer2"
    [blockScroll]="true" (onHide)="cancelNote()" appendTo="body">
    <div class="header p-d-flex p-jc-between">
        <h5>Note</h5>
    </div>
    <p-card class="activity-card">
        <div class="p-d-flex">
            <div class="activity-icon bg-log p-shadow-3">
                <span class="pi pi-file"></span>
            </div>
            <div class="activity-content">
                <ng-container *ngIf="noteArea">
                    <div style="word-break: break-all;" class="p-mb-0" *ngIf="noteData">
                        <div>
                            <h6 class="p-mb-1" style="display: inline-block;">
                                Note - {{ noteData.createdByName }}
                            </h6>
                            <span class="p-ml-4" style="opacity: 0.8;">
                                {{noteData.createdDate | localDate}}
                            </span>
                            <span class="p-ml-4" style="opacity: 0.8;" *ngIf="noteData.updatedDate != null">
                                (last modified: {{noteData.updatedDate | localDate}})
                            </span>
                            <div class="p-jc-end" *ngIf="!isViewMode">
                                <div class="p-mr-1">
                                    <span class="btnBars p-mr-0" style="float: right;"
                                        (click)="showHideUpdateNote(noteData)"
                                        *ngIf="noteData.createdBy == app.user.userId">
                                        <i class="pi pi-pencil"></i>
                                    </span>
                                    <span class="btnBars p-mr-2" style="float: right;" (click)="deleteNote()"
                                        *ngIf="noteData.createdBy == app.user.userId">
                                        <i class="pi pi-trash"></i>
                                    </span>
                                </div>
                            </div>
                            <!-- <div style="word-break: break-all; white-space: pre-line;">{{noteData.comment}}</div> -->
                            <div [innerHtml]="noteData.newComment"></div>

                            <ng-container *ngIf="noteData.noteAttachments && (noteData.noteAttachments.length > 0)">
                                <app-lion-attachment-chips [attachments]="noteData.noteAttachments"
                                    (removeAttachment)="noteData.noteAttachments = $event" [showRemove]="false"
                                    [enableDownload]="true"></app-lion-attachment-chips>
                            </ng-container>
                        </div>
                        <ng-container *ngIf="noteData.noteComments.length > 0">
                            <div *ngFor="let commentObj of noteData.noteComments" class="innerComment" [ngClass]="{'unread-comment': commentObj?.isRead===false}">
                                <h6 class="p-mb-1" style="display: inline-block;">
                                    {{commentObj.comment.createdByName}} Comment
                                </h6>
                                <span class="p-ml-4" style="opacity: 0.8;">
                                    {{commentObj.createdDate | localDate}}
                                </span>
                                <span class="p-ml-4" style="opacity: 0.8;"
                                    *ngIf="commentObj.comment.updatedDate != null">
                                    (last modified: {{commentObj.comment.updatedDate | localDate}})
                                </span>
                                <span class="btnBars p-mr-0" style="float: right;"
                                    (click)="showHideUpdateNoteComment(commentObj)"
                                    *ngIf="commentObj.createdBy == app.user.userId && !isViewMode">
                                    <i class="pi pi-pencil"></i>
                                </span>
                                <span class="btnBars p-mr-2" style="float: right;" (click)="deleteComment(commentObj)"
                                    *ngIf="commentObj.createdBy == app.user.userId && !isViewMode">
                                    <i class="pi pi-trash"></i>
                                </span>
                                <!-- <p>{{commentObj?.comment?.commentMessage}}</p> -->
                                <div [innerHtml]="commentObj?.comment?.newCommentMessage"></div>
                            </div>
                        </ng-container>

                    </div>
                </ng-container>
                <ng-container *ngIf="isUpdateNote">
                    <div class="p-grid">
                        <div class="p-col-6">
                           Note
                       </div>
                        <div class="p-col-6 p-text-right">
                            <span class="btnBars p-mr-0" style="float: right;"
                                (click)="isUpdateNote = false;noteArea = true;">
                                <i class="pi pi-times"></i>
                            </span>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12">
                            <label>Comments</label>
                            <!-- <textarea pInputTextarea name="description" [(ngModel)]="noteComment"
                                autoResize="autoResize" style="width:100%"></textarea> -->
                                <quill-editor id="noteComment" [(ngModel)]="noteComment" placeholder="Enter your comment"[modules]="quillConfig"></quill-editor>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12">
                            <label>
                                Attachments
                                <i class="pi pi-exclamation-circle" [escape]="false" [pTooltip]="multiLineTooltip"
                                    tooltipPosition="top"></i>
                            </label>
                            <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose"
                                [showUploadButton]="false" [showCancelButton]="false" [multiple]="true"
                                (onSelect)="uploadAttachments($event.files)">
                                <ng-template pTemplate="file"></ng-template>
                                <ng-template pTemplate="content">
                                    <ng-container *ngFor="let attachment of noteData?.noteAttachments;let i=index;">
                                        <ng-container *ngIf="attachment && attachment.attachment.statusId === 1">
                                            <div class="p-fileupload-row">
                                                <!-- <button type="button" pButton icon="fa fa-download"
                                                                                (click)="downloadFile(attachment.name, attachment.content, attachment.location)"
                                                                                class="p-button-link p-px-0 p-py-0" label=""></button> -->
                                                <div style="cursor: pointer;">
                                                    <ng-container *ngIf="attachment?.attachment.name.length>15 else splitImageName">
                                                        <div>{{ attachment.attachment.name.substring(0, 14) }}...</div>
                                                    </ng-container>
                                                    <ng-template #splitImageName>
                                                        <div>{{ attachment.attachment.name }}</div>
                                                    </ng-template>
                                                </div>

                                                <div>{{ (attachment?.attachment.sizeInBytes / 1024).toFixed(2) + ' KB' }}</div>
                                                <div>
                                                    <button icon="pi pi-times" pButton (click)="removeAttachment(i)" type="button" icon="pi pi-times"
                                                        [disabled]="isDisabledFilesAction">
                                                    </button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </p-fileUpload>

                        </div>
                    </div>
                    <button pButton label="Save" style="float: right;" [disabled]="noteUpdateLoading" (click)="updateNote()"></button>
                </ng-container>
                <ng-container *ngIf="isUpdateNoteComment">
                    <div class="p-grid">
                        <!-- <div class="p-col-6">
                           <p-dropdown [options]="logTypes" optionLabel="name" appendTo="body" optionValue="id"
                               [(ngModel)]="selectedLog" [disabled]="true"></p-dropdown>
                       </div> -->
                        <div class="p-col-12 p-text-right">
                            <span class="btnBars p-mr-0" style="float: right;"
                                (click)="isUpdateNoteComment = false;noteArea = true;">
                                <i class="pi pi-times"></i>
                            </span>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12">
                            <label>Comments</label>
                            <!-- <textarea pInputTextarea name="description" [(ngModel)]="noteComment"
                                autoResize="autoResize" style="width:100%"></textarea> -->
                                <quill-editor id="noteComment" [(ngModel)]="noteComment" placeholder="Enter your comment"[modules]="quillConfig"></quill-editor>
                        </div>
                    </div>
                    <button pButton label="Save" style="float: right;" (click)="updateNoteComment()"></button>
                </ng-container>
            </div>
        </div>
    </p-card>

    <div *ngIf="!isViewMode">
        <div class="p-grid" *ngIf="!isUpdateNote || !isUpdateNoteComment">
            <div class="p-col-12">
                <label>Comments</label>
                <!-- <textarea pInputTextarea name="description" [row]="3" [(ngModel)]="newComment"
                    style="width:100%"></textarea> -->
                    <quill-editor id="newComment" [(ngModel)]="newComment" placeholder="Enter your comment"[modules]="quillConfig"></quill-editor>

            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <ng-container>
            <button pButton (click)="cancelNote();isView=true;newComment=''" label="Cancel"
                class="p-button-secondary"></button>
            <button pButton label="Save" style="float: right;" (click)="saveNoteComment()"
                *ngIf="newComment !== ''"></button>
        </ng-container>
        <!-- <ng-container>
           <button pButton (click)="cancelLog();" label="Cancel" class="p-button-secondary"></button>
       </ng-container> -->
    </ng-template>
</p-dialog>

